import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const switchV2RecipeDefaultVariants = {
  "orientation": "horizontal"
}
const switchV2RecipeCompoundVariants = []

const switchV2RecipeSlotNames = [
  [
    "root",
    "switchV2Recipe__root"
  ],
  [
    "track",
    "switchV2Recipe__track"
  ],
  [
    "thumb",
    "switchV2Recipe__thumb"
  ]
]
const switchV2RecipeSlotFns = /* @__PURE__ */ switchV2RecipeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, switchV2RecipeDefaultVariants, getSlotCompoundVariant(switchV2RecipeCompoundVariants, slotName))])

const switchV2RecipeFn = memo((props = {}) => {
  return Object.fromEntries(switchV2RecipeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const switchV2RecipeVariantKeys = [
  "appearance",
  "orientation"
]
const getVariantProps = (variants) => ({ ...switchV2RecipeDefaultVariants, ...compact(variants) })

export const switchV2Recipe = /* @__PURE__ */ Object.assign(switchV2RecipeFn, {
  __recipe__: false,
  __name__: 'switchV2Recipe',
  raw: (props) => props,
  variantKeys: switchV2RecipeVariantKeys,
  variantMap: {
  "appearance": [
    "default",
    "primary"
  ],
  "orientation": [
    "horizontal",
    "vertical"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, switchV2RecipeVariantKeys)
  },
  getVariantProps
})